import React from 'react';
import OpenGraphImage from '../../images/HomePage/TravelWebKitBase_HomePageBanner.png';
import bannerImage from '../../images/TermsPage/MrSea_TermsPage_HeroImage.png';
import '../styles/TermsAndPrivacyPolicy.css';
import FAQ from '../components/HomePage/FAQ';

const PrivacyPolicy = () => {
  return (
    <div className="terms-page-immersive">
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="terms-hero__bg-image" style={{ backgroundImage: `url(${bannerImage})` }}></div>
        <div className="terms-hero__overlay"></div>
        <div className="terms-hero__content">
          <h1 className="terms-hero__title">Privacy Policy</h1>
          <p className="terms-hero__subtitle">Learn how Mr Sea Miami Boat Rentals protects your personal information</p>
        </div>
        <div className="terms-hero__wave-container">
          <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
            <defs>
              <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(0, 96, 152, 0.2)" />
              <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(0, 96, 152, 0.4)" />
              <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(0, 96, 152, 0.6)" />
              <use xlinkHref="#gentle-wave" x="48" y="7" fill="#006098" />
            </g>
          </svg>
        </div>
      </section>

      <main className="terms-content">
        <div className="terms-page__content">
          <div className="terms-page__container">
            <h3>1. Introduction</h3>
            <p>At Mr Sea Miami Boat Rentals, we are committed to protecting your privacy and ensuring the security of your personal data when you use our platform for boat rental and yacht charter services.</p>
            <h3>2. Information We Collect</h3>
            <p>We may collect personal information such as name, email address, phone number and details of your boat rental reservations.</p>
            <h3>3. Use of Information</h3>
            <p>We use your information to process boat rental reservations, improve our services, personalize your experience, and send you offers and promotions for yacht charters.</p>
            <h3>4. Data Sharing</h3>
            <p>We do not share your information with third parties, except in cases necessary to process reservations, comply with legal requirements, or improve our boat rental services.</p>
            <h3>5. Information Security</h3>
            <p>We implement security measures to protect your information against unauthorized access, alterations, or improper disclosure.</p>
            <h3>6. Cookies and Similar Technologies</h3>
            <p>We use cookies to improve user experience, analyze traffic, and provide personalized content for our boat rental platform.</p>
            <h3>7. User Rights</h3>
            <p>You can request access, correction, or deletion of your personal data at any time.</p>
            <h3>8. Bugs and Security Vulnerabilities</h3>
            <p>It is prohibited to exploit any bug or security vulnerability or take advantage of any system failure. If you discover any issue, please report it immediately to the <a href="https://altovalleit.com/?utm_source=mrseamiami&utm_medium=referral&utm_campaign=portfolio" target="_blank" rel="noopener noreferrer" style={{ color: '#f2f2f2', fontSize: '1.1rem' }}>AltoValleIT</a> technical team at <a href="mailto:info@altovalleit.com" style={{ color: '#f2f2f2', fontSize: '1.1rem' }}>info@altovalleit.com</a>, or for immediate response, contact <a href="https://www.diaztomas.com/?utm_source=mrseamiami&utm_medium=referral&utm_campaign=portfolio" target="_blank" rel="noopener noreferrer" style={{ color: '#f2f2f2', fontSize: '1.1rem' }}>Tomas</a> or us at Mr Sea Miami. By using this website, you agree not to violate any rules or exploit bugs.</p>
            <h3>9. Policy Changes</h3>
            <p>We reserve the right to update this privacy policy at any time. We will notify you of significant changes.</p>
            <h3>10. Contact</h3>
            <p>If you have questions about our privacy policy, contact us through our customer service at <a href="mailto:hello@mrseamiami.com" style={{ color: '#f2f2f2', fontSize: '1.1rem' }}>hello@mrseamiami.com</a>.</p>
          </div>
        </div>
      </main>
      <FAQ />
    </div>
  );
};

export default PrivacyPolicy;
